







































































import {Vue, Component, Prop} from 'vue-property-decorator';
import ActionBarButton from '@/components/ActionBarButton.vue';
import Dialog from '@/components/Dialog.vue';
import AccountOrganisationAccess from '@/views/accounts/AccountOrganisationAccess.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import Table from '@/components/Table.vue';
import Transformation from '@/classes/transformation';
import AccountService from '@/services/account.service';
import {Getter} from 'vuex-class';
import {Role} from '@/types';
import SearchBar from '@/components/SearchBar.vue';
import EventBus from '@/services/eventbus.service';

@Component({
  components: {SearchBar, Table, ConfirmButton, CancelButton, AccountOrganisationAccess, Dialog, ActionBarButton},
})
export default class AccountUserAudit extends Vue {
  @Getter private hasPermission: any;
  @Getter private activeAccountId: any;

  private loading: boolean = false;
  private search: string = '';

  private itemsPerPage: number = 100;
  private perPage: number = 100;
  private page: number = 1;
  private queryData: any = {
    sort: 'audit.created_at',
    desc: true,
  };
  private allAudit: { rows: any[]; headers: any[]; total: number } = {
    rows: [],
    total: 0,
    headers: [
      {
        text: 'First Name',
        value: 'first_name',
        filterable: false,
        sortable: true,
        queryKey: 'firstName',
        querySortKey: 'user.first_name',
        width: 120,
      },
      {
        text: 'Last Name',
        value: 'last_name',
        filterable: false,
        sortable: true,
        queryKey: 'lastName',
        querySortKey: 'user.last_name',
      },
      {
        text: 'Email',
        value: 'email',
        filterable: true,
        sortable: true,
        queryKey: 'emails',
        querySortKey: 'user.email',
      },
      {
        text: 'Category',
        value: 'category',
        filterable: true,
        sortable: true,
        queryKey: 'categories',
        querySortKey: 'audit.category',
      },
      {
        text: 'Subcategory',
        value: 'sub_category',
        filterable: true,
        sortable: true,
        queryKey: 'subCategories',
        querySortKey: 'audit.sub_category',
      },
      {
        text: 'Organisation',
        value: 'organisation',
        filterable: true,
        sortable: true,
        queryKey: 'organisations',
        querySortKey: 'organisation.name',
      },
      {
        text: 'Summary',
        value: 'summary',
        filterable: false,
        sortable: false,
        hideSort: true,
        queryKey: 'summary',
        querySortKey: 'audit.summary',
      },
      {
        text: 'Activity logged at',
        value: 'created_at',
        filterable: false,
        queryKey: 'created_at',
        querySortKey: 'audit.created_at',
        width: '150px',
      },
    ],
  };

  private async mounted() {
    this.loading = true;
    try {
      await this.getAudit();
    } finally {
      this.loading = false;
    }
  }

  private async getAudit(
      queryData: {
        take?: number;
        skip?: number;
        sort?: string;
        desc: boolean;
        filters?: { [key: string]: any }; } = this.queryData,
      search: string = this.search) {
    this.loading = true;
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(queryData.filters);
    const take = !queryData.take || queryData.take === 0 ? this.perPage : queryData.take;

    try {
      const {
        audits,
        total,
        columnFilters,
      } = await AccountService.getAccountUserAudit(this.activeAccountId, take, queryData.skip, queryData.sort, queryData.desc, mappedFilters, search);
      this.allAudit.rows = audits;
      this.allAudit.total = total;
      Transformation.setTableFilterValues(this.allAudit.headers, columnFilters);

      this.loading = false;

    } finally {
      this.loading = false;
    }
  }

  private async onQueryDataUpdate(data: any) {
    if (!data.sort) {
      data.sort = 'audit.created_at';
      data.desc = true;
    }
    this.queryData = data;
    await this.getAudit(data);
  }

  private async searchUserAudit(searchText: string) {
    this.search = searchText;
    this.page = 1;

    await this.$nextTick();
    await this.getAudit();
  }

  private customSort(items: any[]) {
    return items.sort((a, b) => - a.created_at.localeCompare(b.created_at));
  }

  private async exportCsv() {
    const mappedFilters: {
      [key: string]: { [key: string]: boolean },
    } = Transformation.tableFiltersToMap(this.queryData.filters);
    try {
      const params: {
        take: number;
        skip?: number;
        sort?: string;
        desc?: boolean;
        organisationId?: number;
        search?: string;
        filters?: any;
      } = {
        take: this.queryData.itemsPerPage,
        sort: this.queryData.sort,
      };

      if (this.queryData.page > 1) {
        params.skip = this.queryData.itemsPerPage * (this.queryData.page - 1);
      }
      if (this.queryData.sort) {
        params.desc = this.queryData.desc;
      }
      if (this.search && this.search.trim().length) {
        params.search = this.search.trim();
      }

      function convertToArray(inputObject: any) {
        const outputObject: any = {};

        for (const outerKey in inputObject) {
          if (inputObject.hasOwnProperty(outerKey)) {
            outputObject[outerKey] = [];
            for (const innerKey in inputObject[outerKey]) {
              if (inputObject[outerKey][innerKey]) {
                outputObject[outerKey].push(innerKey);
              }
            }
          }
        }

        return outputObject;
      }

      params.filters = {...convertToArray(mappedFilters)};

      const {job_id} = await AccountService.exportAccountUserAudits(this.activeAccountId, params);
      EventBus.$emit('accountJobCreated', job_id, true);
    } finally {
      this.loading = false;
    }
  }
}
